module.exports = __webpack_public_path__ + "img/20191231155015669.059a377b.jpg";